import React from 'react';
import { Shield } from 'lucide-react';
const MENU_ITEMS = ['MASTER', 'CHARGES', 'RAIL ENTRY', 'PUSH SYNC ASYCUDA', 'BILLING', 'OPERATIONS', 'ANGENT', 'JOB CARD', 'WAREHOUSE', 'USERWISE REPORT', 'ADMIN REPORT', 'OTHER BILLING', 'DATABASE', 'ROLE', 'ERPHRPark'];
interface SidebarProps {
  activePage: string;
  onMenuClick: (page: string) => void;
}
export function Sidebar({
  activePage,
  onMenuClick
}: SidebarProps) {
  const handleItemClick = (item: string) => {
    let pageId = 'dashboard';
    if (item === 'OPERATIONS') pageId = 'operations';
    if (item === 'OTHER BILLING') pageId = 'otherServices';
    if (item === 'CHARGES') pageId = 'serviceRegistration';
    if (item === 'BILLING') pageId = 'applyService';
    if (item === 'ERPHRPark') pageId = 'arms';
    if (item === 'ARMS') pageId = 'arms';
    onMenuClick(pageId);
  };
  return <aside className="w-72 bg-[#FDBA74] flex-shrink-0 flex flex-col h-[calc(100vh-80px)] overflow-y-auto custom-scrollbar" data-id="element-1011">
      <nav className="flex flex-col py-2" data-id="element-1012">
        {MENU_ITEMS.map(item => {
        const highlight = activePage === 'operations' && item === 'OPERATIONS' || activePage === 'otherServices' && item === 'OTHER BILLING' || activePage === 'serviceRegistration' && item === 'CHARGES' || activePage === 'applyService' && item === 'BILLING' || activePage === 'arms' && item === 'ERPHRPark' || activePage === 'dashboard' && item === 'MASTER';
        const isArms = item === 'ERPHRPark';
        return <button key={item} onClick={() => handleItemClick(item)} className={`
                w-full text-left px-6 py-3.5 text-sm font-bold text-white tracking-wide
                hover:bg-white/20 transition-colors border-b border-white/10
                ${highlight ? 'bg-white/10 border-l-4 border-l-white' : 'border-l-4 border-l-transparent'}
                ${isArms ? 'flex items-center gap-2 bg-white/5' : ''}
              `} data-id="element-1013">
              {isArms && <Shield size={16} data-id="element-1014" />}
              {item}
            </button>;
      })}
      </nav>
    </aside>;
}